module.exports = "https://de18y2hs3hlxs.cloudfront.net/25e9b2d1-8359-4702-9df0-21a378808472/images/doctors.png?f2c36e418b5725f34aa32f105b6d7e41";